import { render } from "./WordsDetail.vue?vue&type=template&id=6ecba878&scoped=true&ts=true"
import script from "./WordsDetail.vue?vue&type=script&lang=ts"
export * from "./WordsDetail.vue?vue&type=script&lang=ts"

import "./WordsDetail.vue?vue&type=style&index=0&id=6ecba878&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecba878"]])

export default __exports__